import { render, staticRenderFns } from "./AssignmentComponent.vue?vue&type=template&id=b206750c&scoped=true&"
import script from "./AssignmentComponent.vue?vue&type=script&lang=js&"
export * from "./AssignmentComponent.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentComponent.vue?vue&type=style&index=0&id=b206750c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b206750c",
  null
  
)

export default component.exports